<template lang="pug">
  .top-actions.flex.justify-between.flex-none
    .left-actions
      PlanboardDatePicker
    //- in the center action will be resource group dropdown which is now moved to right for time being
    .center-actions 
    .right-actions.flex.justify-between.flex-none
      BriqMultiselect.resource-groups-dropdown(
        :options="resourceGroups" 
        display="ResourceName"
        track-by="ResourceKey"
        v-model="resourceGroupItem"
        :required="true"
        :disabled="isFetching"
        )
    //-
      BriqInput.mr-XS(
        placeholder="Search booking"
      )
      BriqButton.mr-XS( variant="main") Create booking
      BriqButton.mr-XS( variant="secondary") 
        BriqIcon(name="icon-manage-menu-icon" customStyle="vertical-align: middle;")
</template>
<script>
import { map, uniqBy, pipe, prop, sortBy, filter, find, propEq } from 'ramda'
import { mapGetters, mapMutations } from 'vuex'
import PlanboardDatePicker from '@/vue/planboard/top-actions/PlanboardDatePicker.vue'

export default {
  name: 'TopActions',
  components: {
    PlanboardDatePicker,
  },
  computed: {
    ...mapGetters('planboardModule', ['planboardData', 'isFetching']),
    resourceGroupItem: {
      get() {
        if (!this.isFetching) {
          return this.$route.params.resourceGroupKey
        } else return null
      },
      set(v) {
        if (v !== this.$route.params.resourceGroupKey && v !== null)
          this.$router.push({
            name: 'Planboard',
            params: { resourceGroupKey: v },
          })
      },
    },
    resourceGroups() {
      if (this.isFetching) return []
      return pipe(
        map(r => {
          if (r.ParentResourceKey && r.Exclusivity !== 'None')
            return {
              ResourceKey: r.ParentResourceKey,
              ResourceName: r.ParentResourceName,
            }
        }),
        filter(r => !!r),
        uniqBy(prop('ResourceKey')),
        sortBy(prop('ResourceName')),
      )(this.planboardData?.Resources)
    },
  },
}
</script>

<style scoped lang="stylus">
.top-actions
  padding 30px
  background-color white

  .right-actions
    width 300px
    height 40px

  .left-actions
    width 350px

  .right-actions
    .resource-groups-dropdown
      width 300px
</style>
